import { Link } from "react-router-dom";
import { CalendarDays, MapPin, Paperclip, Users } from "lucide-react";
import type { ActivityListItem } from "../api/types";
import { formatDate, formatTimeRange } from "../lib/format";
import { Card, StatusBadge, ValidationBadge } from "./ui";

/** Kartu ringkas satu kegiatan pada daftar/feed. */
export function ActivityCard({ activity }: { activity: ActivityListItem }) {
  return (
    <Card className="transition hover:ring-brand-300">
      <Link to={`/kegiatan/${activity.id}`} className="block space-y-3">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-mono text-xs text-slate-500">{activity.activityCode}</span>
          <StatusBadge status={activity.status} />
          <ValidationBadge status={activity.validationStatus} />
        </div>

        <h3 className="text-base font-semibold text-slate-900">{activity.title}</h3>

        <p className="line-clamp-2 text-sm text-slate-600">{activity.description}</p>

        <dl className="grid grid-cols-1 gap-2 text-xs text-slate-600 sm:grid-cols-2">
          <div className="flex items-center gap-2">
            <CalendarDays className="size-4 shrink-0 text-slate-400" aria-hidden />
            <span>
              {formatDate(activity.activityDate)} ·{" "}
              {formatTimeRange(activity.startTime, activity.endTime)}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <MapPin className="size-4 shrink-0 text-slate-400" aria-hidden />
            <span className="truncate">{activity.location}</span>
          </div>
          <div className="flex items-center gap-2">
            <Paperclip className="size-4 shrink-0 text-slate-400" aria-hidden />
            <span>{activity.evidenceCount} bukti</span>
          </div>
          <div className="flex items-center gap-2">
            <Users className="size-4 shrink-0 text-slate-400" aria-hidden />
            <span>{activity.participantCount} peserta</span>
          </div>
        </dl>

        <div className="flex flex-wrap items-center gap-2 text-xs text-slate-500">
          <span className="rounded-full bg-slate-100 px-2 py-0.5 font-medium">
            {activity.category.name}
          </span>
          <span>{activity.studyProgram.name}</span>
          <span>·</span>
          <span>{activity.submittedBy.fullName}</span>
        </div>
      </Link>
    </Card>
  );
}
